import { render, staticRenderFns } from "./OptionsForm.vue?vue&type=template&id=6150ee51"
import script from "./OptionsForm.vue?vue&type=script&lang=js"
export * from "./OptionsForm.vue?vue&type=script&lang=js"
import style0 from "./OptionsForm.vue?vue&type=style&index=0&id=6150ee51&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports